import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import SuccessionDashboard from '../components/Succession/SuccessionDashboard';
import SuccessionQuestionnaireContainer from '../containers/SuccessionQuestionnaireContainer';
import SuccessionDealsContainer from '../containers/Succession/Deals/SuccessionDealsContainer';
import DealWizardContainer from '../containers/Succession/Deals/DealWizardContainer';

const SuccessionRoutes = () => {
  return (
    <Switch>
      <Route exact path="/succession/assistant" render={() => <Redirect to="/assistant" />} />
      <Route exact path="/succession/dashboard" component={SuccessionDashboard} />
      <Route exact path="/succession/questionnaire" component={SuccessionQuestionnaireContainer} />
      <Route exact path="/succession/deals/wizard" component={DealWizardContainer} />
      <Route path="/succession/deals" component={SuccessionDealsContainer} />
      <Route path="/succession/deals/:dealId/:view" component={SuccessionDealsContainer} />
      <Route path="/succession/deals/:dealId" component={SuccessionDealsContainer} />
    </Switch>
  );
};

export default SuccessionRoutes; 